import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/i18n";
import "@/App.css";
import { AuthProvider } from "@/lib/auth";
import { CurrencyProvider } from "@/lib/currency";
import { Toaster } from "@/components/ui/sonner";
import NavBar from "@/components/NavBar";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Marketplace from "@/pages/Marketplace";
import IcoDetail from "@/pages/IcoDetail";
import LandlordDashboard from "@/pages/LandlordDashboard";
import InvestorPortfolio from "@/pages/InvestorPortfolio";
import TenantDashboard from "@/pages/TenantDashboard";
import AmcDashboard from "@/pages/AmcDashboard";
import Activity from "@/pages/Activity";
import Wallet from "@/pages/Wallet";

function App() {
  return (
    <AuthProvider>
      <CurrencyProvider>
        <BrowserRouter>
          <NavBar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/ico/:id" element={<IcoDetail />} />
            <Route path="/landlord" element={
              <ProtectedRoute roles={["landlord"]}><LandlordDashboard /></ProtectedRoute>
            } />
            <Route path="/portfolio" element={
              <ProtectedRoute roles={["investor"]}><InvestorPortfolio /></ProtectedRoute>
            } />
            <Route path="/tenant" element={
              <ProtectedRoute roles={["tenant"]}><TenantDashboard /></ProtectedRoute>
            } />
            <Route path="/amc" element={
              <ProtectedRoute roles={["amc"]}><AmcDashboard /></ProtectedRoute>
            } />
            <Route path="/activity" element={
              <ProtectedRoute><Activity /></ProtectedRoute>
            } />
            <Route path="/wallet" element={
              <ProtectedRoute><Wallet /></ProtectedRoute>
            } />
          </Routes>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </CurrencyProvider>
    </AuthProvider>
  );
}

export default App;
